import { motion } from "framer-motion";
import bgImage from "../../assets/images/hero-image-20.jpg";
import exp1 from "../../assets/images/expedition/exp1.jpg";
import exp2 from "../../assets/images/expedition/exp2.jpg";
import exp3 from "../../assets/images/expedition/exp3.jpg";
import logo from "../../assets/images/logo1.png";

const expeditions = [
  {
    id: "01",
    title: "Everest Basecamp Trek",
    year: "2026",
   service: "Technical | High-Altitude Climb",
    image: exp1,
    logo: logo,
    link: "#",
  },
   {
    id: "02",
    title: "K2 Basecamp Trek",
    year: "2026",
    service: "Technical | High-Altitude Climb",
    image: exp3,
    logo: logo,
    link: "#",
  },
  {
    id: "03",
    title: "Everest Basecamp Trek",
    year: "2026",
    service: "Technical | High-Altitude Climb",
    image: exp2,
    logo: logo,
    link: "#",
  }
];

const ExpeditionSection = () => {
  return (
    <section
      className="relative w-full text-white py-28 bg-cover bg-center bg-fixed overflow-hidden"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Watermark + Heading */}
      <div className="relative flex flex-col items-center justify-center mb-16 md:mb-24 z-10 ">
      
      {/* BACKGROUND WORD - UPCOMING */}
      <h1
        className="font-black text-white/10 tracking-tight leading-none select-none pointer-events-none
                  z-0"
        style={{
          fontSize: "clamp(4rem, 17vw, 14rem)",
          lineHeight: "0.9"
        }}
      >
        UPCOMING
      </h1>

      {/* FOREGROUND WORD - EXPEDITIONS */}
      <h3
        className="
          relative z-10 font-bold text-white/70 tracking-tight leading-none select-none text-center
          px-4
          -mt-[1.5rem] sm:-mt-[2.5rem] md:-mt-[3.5rem] lg:-mt-[5rem]
        "
        style={{
          fontSize: "clamp(2.7rem, 11vw, 10.5rem)",
          lineHeight: "0.85"
        }}
      >
        EXPEDITIONS
      </h3>

    </div>


      {/* Cards */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 grid gap-10 md:grid-cols-3">
        {expeditions.map((item) => (
          <motion.a
            key={item.id}
            href={item.link}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative rounded-xl overflow-hidden border border-gray-200/10 hover:border-white/60 backdrop-blur-md transition duration-300 
            bg-gray-100/50 h-[420px] flex flex-col"
          >
            {/* Image */}
            <div className="relative flex-grow w-full overflow-hidden bg-black/20">
              <img
                src={item.image}
                alt={item.title}
                className="object-cover w-full h-full"
              />

              <div className="absolute inset-0 bg-black/10"></div>

              {/* Optional center logo overlay */}
              {/* <img
                src={item.logo}
                alt="Logo"
                className="absolute top-4 left-4 w-10 opacity-80"
              /> */}
            </div>

            {/* Info Footer */}
            <div className="absolute bottom-0 left-0 right-0 px-5 py-3 bg-black/60 backdrop-blur-sm">
              <div className="flex justify-between items-center">
                <p className="text-white font-semibold text-sm sm:text-base">
                  {item.title}
                </p>
                <p className="text-gray-300 text-xs sm:text-sm">{item.year}</p>
              </div>
              <p className="text-gray-300 text-xs mt-1">{item.service}</p>
            </div>
          </motion.a>
        ))}
      </div>

      {/* CTA */}
      <div className="relative z-20 text-center mt-16">
        <a
          href="/adventures/expeditions"
          className="text-white text-lg font-semibold md:text-xl border-b border-white/40 hover:border-white pb-1 transition"
        >
          View All Expeditions →
        </a>
      </div>
    </section>
  );
};

export default ExpeditionSection;
